/* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect } from "react";
// import { useAxios } from "utils/CustomHooks";
import { ReactComponent as DeleteIcon } from "assets/icons/delete-icon.svg";
import { Table } from "react-bootstrap";
import PropTypes from "prop-types";
import { toPersianNum } from "utils/helpers";
import styles from "./StockTable.module.scss";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const StockTable = ({ stockRows, removeRow, haveDate, role }) => {
    // API calls

    const columns = [
        { id: 1, title: "وندور" },
        { id: 2, title: "نام" },
        { id: 3, title: "شیفت" },
        { id: 4, title: "علت قرارگیری در دسته" },
        { id: 5, title: "تعداد" },
        { id: 6, title: "عملیات" },
    ];

    // calling API
    // useEffect(() => {
    //     if (haveDate) {
    //         setFetchParams({
    //             method: "get",
    //             url: "/admin/stock",
    //             params: { ...filterParams, type: actionType },
    //         });
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [filterParams]);

    const remove = (item) => {
        removeRow(item);
    };

    // const history = useHistory();

    // Should send which page is (add, deduct or inventory)
    // const redirectToUpdatePage = (id) => {
    //     history.push(`/update-stock-${'add'}/${id}`);
    // };

    return (
        <>
            <div className="page-template-table-container mt-1">
                <Table
                    bordered
                    hover
                    className={`${styles.tableResponsive} kitchen-list-container kitchen-waste-list-container  margin-t30 rtl`}
                >
                    <thead>
                        <tr>
                            {columns?.map((item) => (
                                <th key={item.id}>{item.title}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {stockRows?.map((item) => {
                            return (
                                <tr key={item.food_id}>
                                    <td>
                                        {haveDate
                                            ? item?.vendor?.title
                                            : item?.vendor_title}
                                    </td>
                                    <td>
                                        {haveDate
                                            ? item.food?.title
                                            : item.food_title}
                                        {haveDate
                                            ? item.good?.title
                                            : item.good_title}
                                    </td>
                                    <td>{item.shift_str}</td>
                                    {haveDate && role !== "hub" && (
                                        <td>{item.hub?.title}</td>
                                    )}
                                    {haveDate && <td>{item?.date_str}</td>}
                                    {haveDate && <td>{item?.time_str}</td>}
                                    <td>
                                        {haveDate
                                            ? item.reason_str
                                            : item.reason_title}
                                    </td>
                                    <td dir="ltr">
                                        {item.count
                                            ? toPersianNum(item.count, true)
                                            : toPersianNum(item.stock, true)}
                                    </td>
                                    {item.expiration && (
                                        <td>
                                            {item.expiration
                                                ?.convert(persian, persian_fa)
                                                .format("YYYY-MM-DD")}
                                        </td>
                                    )}
                                    {!haveDate && (
                                        <td>
                                            <button
                                                className="delete-btn"
                                                onClick={() => remove(item)}
                                            >
                                                <DeleteIcon />
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>

            {/* Pagination part */}
            {/* {!haveDate && (
                <Button
                    btnText={"ثبت"}
                    className={`${styles.submitButtonResponsive} solid is-violet big pushLeft margin-t30`}
                    handleClick={() => handleSubmit()}
                    loading={loading}
                />
            )} */}
            {/* {haveDate && response && (
                <Pagination
                    totalCount={response.total}
                    pageSize={response.per_page}
                    currentPage={response.current_page}
                    onPageChange={(currentPage) =>
                        setFetchParams({
                            method: "get",
                            url: `/admin/stock?page=${currentPage}&pagesize=${response.per_page}`,
                            params: filterParams,
                        })
                    }
                />
            )} */}
        </>
    );
};

StockTable.propTypes = {
    columns: PropTypes.array,
    loading: PropTypes.bool,
    role: PropTypes.string,
    stockRows: PropTypes.array,
    removeRow: PropTypes.func,
    emptyText: PropTypes.string,
    haveDate: PropTypes.bool,
    handleSubmit: PropTypes.func,
};

export default StockTable;
